import { Component } from "@/types"
import { Stack } from "@/ui/atoms/layout/Stack/Stack"
import { BodyText } from "@/ui/atoms/type/BodyText"
import { Title } from "@/ui/atoms/type/Title"
import { cx } from "@/utils/cx"
import { tx } from "@/utils/tx"

export const COMPONENT_NAME = "tile"

export const presets = {}

export interface Props extends Component {
  title: string
  body: string
  source: string
}

export function Tile({ title, body, source, className, testId = COMPONENT_NAME }: Props) {
  return (
    <Stack
      className={cx(
        "p-6 bg-global-header",
        "rounded-tl-[2.5em] rounded-br-[2.5em]",
        "relative overflow-hidden",
        className,
      )}
      testId={testId}
    >
      <Title size="xl" className="lg:text-[48px]" testId={tx(testId, "title")}>
        {title}
      </Title>
      <BodyText className="grow text-white" size="lg" testId={tx(testId, "body")}>
        {body}
      </BodyText>
      <BodyText className="text-gray-400" testId={tx(testId, "source")}>
        {source}
      </BodyText>
      <div className="absolute bottom-0 left-0 right-0 h-1.5 bg-current"></div>
    </Stack>
  )
}
